export default "__VITE_ASSET__C630gAeK__"